export const iconFontAwesomeAlphabetB = (
	<i className="fa-solid fa-b"></i>
);
